






























































































































import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import TextField from '@/components/TextField.vue';
import ChevronIcon from '@/components/ChevronIcon.vue';
import BackArrowIcon from '@/components/BackArrowIcon.vue';
import { LocaleMessages } from 'vue-i18n';
import isMobile from '@/utils/isMobile';

const RESULTS_CONTAINER_ID = '#resultsContainer';

@Component({
  components: {
    TextField,
    ChevronIcon,
    BackArrowIcon,
    Loader: () => import('@/components/Loader.vue'),
  },
})
export default class AutocompleteField extends Vue {
  $refs!: Vue['$refs'] & {
    textField: TextField;
  };

  @Model('change') modelValue!: any;
  @Prop({ type: [String, Object] }) label?: string | LocaleMessages;
  @Prop({ type: Array, required: true }) items!: any[];
  @Prop({ type: String, default: 'name' }) itemText!: string;
  @Prop({ type: String, default: 'id' }) itemKey!: string;
  @Prop({ type: Function }) filter?: (
    item: any,
    queryText: string,
    itemText: string
  ) => any;
  @Prop({ type: Boolean, default: false }) loading!: boolean;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
  @Prop({ type: Boolean, default: false }) showChangeButton!: string;
  @Prop({ type: String, default: false }) name!: string;

  private query: string | null = null;
  private focused: boolean = false;
  private resultsHover: boolean = false;
  private isMobile: boolean = false;
  private windowHeight: number = 0;
  private scrollPosition = 0;
  private throttleTimeout: number | null = null;
  private scrollEnded = false;

  private get isCustomFont() {
    return this.$store.getters.isVox;
  }

  private get showLoader(): boolean {
    return this.loading && this.focused;
  }

  private get showNoData(): boolean {
    return !this.items.length && !this.loading && this.focused;
  }

  private get showResults(): boolean {
    return !!this.items.length && (this.focused || this.resultsHover);
  }

  private get showShadowOnScroll(): boolean {
    return this.scrollPosition > 30 && this.focused;
  }

  private created() {
    this.isMobile = isMobile();
    this.windowHeight = window.innerHeight;
    window.visualViewport?.addEventListener(
      'resize',
      this.onContainerSizeChange
    );
  }

  beforeDestroy() {
    window.visualViewport?.removeEventListener(
      'resize',
      this.onContainerSizeChange
    );

    const resultsContainer = document.querySelector(
      RESULTS_CONTAINER_ID
    ) as HTMLElement;

    resultsContainer?.removeEventListener(
      'touchstart',
      this.resultsContainerTouchStartEventHandler
    );
  }

  private onInputClear() {
    this.query = '';
    this.$emit('search', this.query);
    this.$emit('clear');
  }

  private onScrollHandler(e: Event) {
    this.scrollPosition = (e.target as HTMLElement)?.scrollTop;
  }

  private resultsContainerTouchStartEventHandler() {
    const textFieldHtmlEl = this.$refs.textField.$el.querySelector('input');
    textFieldHtmlEl?.blur();
  }

  @Emit('search')
  onSearch(value: any): any {
    this.query = value;
    return value;
  }

  @Emit('change')
  onChange(value: any): any {
    this.focused = false;
    this.resultsHover = false;
    return value;
  }

  @Watch('scrollPosition')
  onScrollPositionChange(current: number) {
    if (this.throttleTimeout) {
      clearTimeout(this.throttleTimeout);
    }

    this.throttleTimeout = window.setTimeout(() => {
      const resultsContainer = document.querySelector(
        RESULTS_CONTAINER_ID
      ) as HTMLElement;

      const scrollHeight =
        resultsContainer?.scrollHeight - resultsContainer?.clientHeight;
      if (this.scrollPosition + 30 > scrollHeight) {
        this.$emit('fetch-next', this.query || null);
        this.scrollEnded = true;
      }

      this.throttleTimeout = null;
    }, 200);
  }

  @Watch('items')
  onItemsChange() {
    this.scrollEnded = false;
  }

  @Watch('focused')
  onFocusedChange(current: boolean) {
    if (current && !this.query) {
      this.$emit('focused');
    }
  }

  @Watch('modelValue')
  private onModelValueChange(current: any) {
    if (current) {
      this.query = '';
    }
  }

  @Watch('showResults')
  onShowResults(current: boolean) {
    this.$nextTick(() => {
      this.$store.dispatch('setIsFullscreenDropdown', current);

      const resultsContainer = document.querySelector(
        RESULTS_CONTAINER_ID
      ) as HTMLElement;

      if (current) {
        // this.resultsContainerTouchStartEventHandler();

        resultsContainer?.addEventListener(
          'touchstart',
          this.resultsContainerTouchStartEventHandler
        );
      }
      if (!current) {
        resultsContainer?.removeEventListener('scroll', this.onScrollHandler);
        return;
      }

      resultsContainer?.addEventListener('scroll', this.onScrollHandler);
    });
  }

  private onContainerSizeChange() {
    if (window.innerHeight !== this.windowHeight) {
      window.scroll(0, 0);
      this.windowHeight = window.innerHeight;
    }
  }

  onQueryChange(value: string) {
    this.onChange(null);
    this.query = value;
  }
}
